import { render } from "./ArtistPopup.vue?vue&type=template&id=47c0266e&scoped=true&ts=true"
import script from "./ArtistPopup.vue?vue&type=script&lang=ts"
export * from "./ArtistPopup.vue?vue&type=script&lang=ts"

import "./ArtistPopup.vue?vue&type=style&index=0&id=47c0266e&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-47c0266e"]])

export default __exports__